// /src/components/calendar/CalendarGrid.js
import { useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function CalendarGrid({ token, current, setCurrent, selected, setSelected, events, setEvents }) {
  const today = new Date();

  useEffect(() => {
    if (!token) return;
    const start = new Date(current.year, current.month, 1).toISOString();
    const end = new Date(current.year, current.month + 1, 0, 23, 59).toISOString();

    fetch(`/api/gcalendarevents?timeMin=${start}&timeMax=${end}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => { if (Array.isArray(data)) setEvents(data); })
      .catch(console.error);
  }, [current, token]);

  const firstDay = new Date(current.year, current.month, 1).getDay();
  const daysInMonth = new Date(current.year, current.month + 1, 0).getDate();
  const cells = Array.from({ length: firstDay + daysInMonth }, (_, i) =>
    i < firstDay ? null : i - firstDay + 1
  );

  const eventsOnDay = (day) => {
    if (!day) return [];
    return events.filter(e => {
      const d = new Date(e.start?.dateTime || e.start?.date);
      return d.getFullYear() === current.year && d.getMonth() === current.month && d.getDate() === day;
    });
  };

  const isToday = (day) =>
    day === today.getDate() && current.month === today.getMonth() && current.year === today.getFullYear();

  const prevMonth = () => setCurrent(c => { const d = new Date(c.year, c.month - 1); return { year: d.getFullYear(), month: d.getMonth() }; });
  const nextMonth = () => setCurrent(c => { const d = new Date(c.year, c.month + 1); return { year: d.getFullYear(), month: d.getMonth() }; });

  return (
    <div className="card">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: "1px solid #f1f5f9" }}>
        <button onClick={prevMonth} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, borderRadius: 6, color: "#64748b" }}><ChevronLeft size={18} /></button>
        <span style={{ fontWeight: 700, fontSize: 16, color: "#0f172a" }}>{MONTHS[current.month]} {current.year}</span>
        <button onClick={nextMonth} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, borderRadius: 6, color: "#64748b" }}><ChevronRight size={18} /></button>
      </div>
      <div style={{ padding: "12px 16px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", marginBottom: 8 }}>
          {DAYS.map(d => (
            <div key={d} style={{ textAlign: "center", fontSize: 11, fontWeight: 600, color: "#94a3b8", padding: "4px 0" }}>{d}</div>
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 2 }}>
          {cells.map((day, i) => {
            const dayEvents = eventsOnDay(day);
            const isSelected = day === selected;
            const isTodayDay = isToday(day);
            return (
              <div key={i} onClick={() => day && setSelected(day === selected ? null : day)}
                style={{
                  minHeight: 64, padding: "4px 6px", borderRadius: 8, cursor: day ? "pointer" : "default",
                  background: isSelected ? "#0f172a" : isTodayDay ? "#eff6ff" : "transparent",
                  border: isTodayDay && !isSelected ? "1px solid #bfdbfe" : "1px solid transparent",
                  transition: "background 0.1s",
                }}>
                {day && (
                  <>
                    <div style={{ fontSize: 13, fontWeight: isTodayDay ? 700 : 400, marginBottom: 4,
                      color: isSelected ? "#fff" : isTodayDay ? "#2563eb" : "#374151" }}>
                      {day}
                    </div>
                    {dayEvents.slice(0, 2).map(e => (
                      <div key={e.id} style={{
                        fontSize: 10, borderRadius: 3, padding: "1px 4px", marginBottom: 2,
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                        background: isSelected ? "#334155" : "#dbeafe",
                        color: isSelected ? "#e2e8f0" : "#1e40af",
                      }}>
                        {e.summary}
                      </div>
                    ))}
                    {dayEvents.length > 2 && (
                      <div style={{ fontSize: 10, color: isSelected ? "#94a3b8" : "#64748b" }}>+{dayEvents.length - 2} more</div>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}